var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    ref: "room-video-card",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "dark": "",
      "outlined": "",
      "max-height": "calc(100vh - 46px - 24px - 12px - 16px - 64px)"
    }
  }, [_c('v-responsive', {
    ref: "container",
    attrs: {
      "aspect-ratio": 4 / 3,
      "content-class": "grey lighten-5"
    }
  }, [_c('video', _vm._b({
    staticClass: "room-video__video mb-n8",
    attrs: {
      "autoplay": "",
      "playsinline": ""
    },
    domProps: {
      "srcObject": _vm.stream_video
    }
  }, 'video', {
    width: _vm.width,
    height: _vm.height
  }, false))]), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.enabled_video === false,
      expression: "enabled_video === false"
    }],
    attrs: {
      "absolute": "",
      "color": "black",
      "opacity": "1"
    }
  }, [_c('v-row', {
    staticClass: "flex-column grey--text",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "80",
      "color": "grey"
    }
  }, [_vm._v("mdi-camera-off")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("카메라가 꺼져있습니다")])])], 1)], 1)], 1), _c('div', {
    staticClass: "room-video__title"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")]), !!_vm.peer ? _c('video-voice', _vm._b({}, 'video-voice', {
    report: _vm.report
  }, false)) : _vm._e(), _vm.enabled_audio === false ? [_c('v-icon', {
    staticClass: "ml-8",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-microphone-off")])] : _vm._e()], 2), !!_vm.peer ? _c('video-border', _vm._b({}, 'video-border', {
    report: _vm.report
  }, false)) : _vm._e(), !!_vm.peer ? _c('video-report', _vm._b({
    model: {
      value: _vm.report,
      callback: function callback($$v) {
        _vm.report = $$v;
      },
      expression: "report"
    }
  }, 'video-report', {
    peer: _vm.peer
  }, false)) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }